/** Códigos de erro do módulo de estrutura da obra. */
export const STRUCTURE_ERROR = {
  TOWER_NAME_TAKEN: 'STRUCTURE.TOWER_NAME_TAKEN',
  FLOOR_NAME_TAKEN: 'STRUCTURE.FLOOR_NAME_TAKEN',
  FLOOR_LEVEL_TAKEN: 'STRUCTURE.FLOOR_LEVEL_TAKEN',
  DISCIPLINE_NAME_TAKEN: 'STRUCTURE.DISCIPLINE_NAME_TAKEN',
  ACTIVITY_EXISTS: 'STRUCTURE.ACTIVITY_EXISTS',
  ACTIVITY_IDENTITY_IMMUTABLE: 'STRUCTURE.ACTIVITY_IDENTITY_IMMUTABLE',
  INVALID_STATUS_TRANSITION: 'STRUCTURE.INVALID_STATUS_TRANSITION',
  HAS_ACTIVE_CHILDREN: 'STRUCTURE.HAS_ACTIVE_CHILDREN',
  TOWER_NOT_FOUND: 'STRUCTURE.TOWER_NOT_FOUND',
  FLOOR_NOT_FOUND: 'STRUCTURE.FLOOR_NOT_FOUND',
  DISCIPLINE_NOT_FOUND: 'STRUCTURE.DISCIPLINE_NOT_FOUND',
  ACTIVITY_NOT_FOUND: 'STRUCTURE.ACTIVITY_NOT_FOUND',
  INVALID_LEVEL_RANGE: 'STRUCTURE.INVALID_LEVEL_RANGE',
  RANGE_TOO_LARGE: 'STRUCTURE.RANGE_TOO_LARGE',
  DISCIPLINE_WRONG_PROJECT: 'STRUCTURE.DISCIPLINE_WRONG_PROJECT',
  DISCIPLINE_INACTIVE: 'STRUCTURE.DISCIPLINE_INACTIVE',
} as const;

export const STRUCTURE_ERROR_MESSAGE: Readonly<Record<string, string>> = {
  [STRUCTURE_ERROR.TOWER_NAME_TAKEN]: 'Já existe uma torre com este nome nesta obra.',
  [STRUCTURE_ERROR.FLOOR_NAME_TAKEN]: 'Já existe um pavimento com este nome nesta torre.',
  [STRUCTURE_ERROR.FLOOR_LEVEL_TAKEN]: 'Já existe um pavimento neste nível nesta torre.',
  [STRUCTURE_ERROR.DISCIPLINE_NAME_TAKEN]: 'Já existe uma disciplina com este nome.',
  [STRUCTURE_ERROR.ACTIVITY_EXISTS]: 'Esta disciplina já está aplicada a este pavimento.',
  [STRUCTURE_ERROR.ACTIVITY_IDENTITY_IMMUTABLE]:
    'O pavimento e a disciplina de uma atividade não podem ser alterados. Remova a atividade e crie outra.',
  [STRUCTURE_ERROR.INVALID_STATUS_TRANSITION]: 'Esta mudança de situação não é permitida.',
  [STRUCTURE_ERROR.HAS_ACTIVE_CHILDREN]:
    'Este item ainda tem conteúdo. Confirme a exclusão em cascata para removê-lo junto.',
  [STRUCTURE_ERROR.TOWER_NOT_FOUND]: 'Torre não encontrada.',
  [STRUCTURE_ERROR.FLOOR_NOT_FOUND]: 'Pavimento não encontrado.',
  [STRUCTURE_ERROR.DISCIPLINE_NOT_FOUND]: 'Disciplina não encontrada.',
  [STRUCTURE_ERROR.ACTIVITY_NOT_FOUND]: 'Atividade não encontrada.',
  [STRUCTURE_ERROR.INVALID_LEVEL_RANGE]: 'O nível inicial deve ser menor ou igual ao final.',
  [STRUCTURE_ERROR.RANGE_TOO_LARGE]: 'Crie no máximo 100 pavimentos de uma vez.',
  [STRUCTURE_ERROR.DISCIPLINE_WRONG_PROJECT]: 'Esta disciplina pertence a outra obra.',
  [STRUCTURE_ERROR.DISCIPLINE_INACTIVE]:
    'Disciplina desativada não é ligada a pavimento. Reative-a em Configurações → Disciplinas.',
};
